import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=63a57bd7&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a57bd7')) {
      api.createRecord('63a57bd7', component.options)
    } else {
      api.reload('63a57bd7', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=63a57bd7&", function () {
      api.rerender('63a57bd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/GlobalFilters/Modals/DeleteModal.vue"
export default component.exports